import { escapeHtmlAttributes } from './escapeHtmlAttributes';

export function getCustomAttributes(customEvents, dataAttribute = 'data-ga-') {
    const eventKeys = Object.keys(customEvents);
    let customAttributes = '';
    if(eventKeys.length) {
        for (let i = 0; i < eventKeys.length; i++) {
            const key = _.kebabCase(eventKeys[i]);
            const value = customEvents[eventKeys[i]];
            customAttributes = customAttributes + `${dataAttribute}${key}=${value} `;
        }
    }

    return customAttributes;
}

export function gaEvent(eventCategory = '', eventAction = '', eventLabel = '', customEvents = {}) {
    // NOTE: The string "PAGE_TYPE" can be used as a special case value.
    // When "PAGE_TYPE" is used, it gets replaced by the store's core.pageType.

    const safe = this.env.filters.safe.bind(this);
    const customAttributes = getCustomAttributes(customEvents);

    return safe(`data-ga-link-track data-ga-event-category="${escapeHtmlAttributes(eventCategory)}"
        data-ga-event-action="${escapeHtmlAttributes(eventAction)}"
        data-ga-event-label="${escapeHtmlAttributes(eventLabel)}"
        ${customAttributes}`);
}

export function gaInViewEvent(eventCategory = '', eventAction = '', eventLabel = '', customEvents = {}) {
    const safe = this.env.filters.safe.bind(this);
    const customAttributes = getCustomAttributes(customEvents, 'data-ga-inview-');

    return safe(`data-ga-inview-track data-ga-inview-event-category="${escapeHtmlAttributes(eventCategory)}"
        data-ga-inview-event-action="${escapeHtmlAttributes(eventAction)}"
        data-ga-inview-event-label="${escapeHtmlAttributes(eventLabel)}"
        ${customAttributes}`);
}
